import { render, staticRenderFns } from "./AdminInvoicesScreen.vue?vue&type=template&id=c5272794&scoped=true&"
import script from "./AdminInvoicesScreen.vue?vue&type=script&lang=js&"
export * from "./AdminInvoicesScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5272794",
  null
  
)

export default component.exports